import React, { createContext, useContext, useState, ReactNode } from "react";
import { RegisterCredentials } from "@/types/auth";

interface RegisterContextType {
  credentials: Partial<RegisterCredentials>;
  setCredentials: (credentials: Partial<RegisterCredentials>) => void;
  updateCredentials: (updates: Partial<RegisterCredentials>) => void;
  clearCredentials: () => void;
}

const RegisterContext = createContext<RegisterContextType | undefined>(
  undefined
);

export const RegisterProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [credentials, setCredentialsState] = useState<
    Partial<RegisterCredentials>
  >({
    consentHealth: false,
    consentAge: false,
    consentFamily: false,
  });

  const setCredentials = (newCredentials: Partial<RegisterCredentials>) => {
    setCredentialsState(newCredentials);
  };

  const updateCredentials = (updates: Partial<RegisterCredentials>) => {
    setCredentialsState((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const clearCredentials = () => {
    setCredentialsState({
      consentHealth: false,
      consentAge: false,
      consentFamily: false,
    });
  };

  return (
    <RegisterContext.Provider
      value={{
        credentials,
        setCredentials,
        updateCredentials,
        clearCredentials,
      }}
    >
      {children}
    </RegisterContext.Provider>
  );
};

export const useRegisterContext = () => {
  const context = useContext(RegisterContext);
  if (!context) {
    throw new Error("useRegisterContext must be used within RegisterProvider");
  }
  return context;
};
